import useSWR from 'swr';
import {
  ADDON_DVP,
  ADDON_PMV,
  ADDON_EXTENSION,
  SECOND_CHECKOUT_SOURCE,
} from '../brands/default/constants';
import {
  ADDON_PAYMENT_INSTRUMENTS,
  URLADDON,
  URLCOMPLEMENTARYDEALS,
} from '../brands/default/services';
import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import httpCommonHeaders from './httpCommonHeaders';

const fetchWithAxios = async (url) => {
  const headers = httpCommonHeaders();
  headers.ALT_PAYMENT_METHODS = 'GOOGLE_PAY,APPLE_PAY';

  const { data } = await axios(url, {
    headers,
    method: 'GET',
    withCredentials: true,
  });

  return data || [];
};

export const usePaymentInfo = () => {
  const url = `${ADDON_PAYMENT_INSTRUMENTS}`;
  const { data } = useSWR(url, fetchWithAxios);

  if (data?.data) return data.data;

  return null;
};

// eslint-disable-next-line consistent-return
export const getAddsOnServiceData = async (orderId, queryParameters) => {
  try {
    return await axios({
      headers: httpCommonHeaders({ customVersion: 'v1.2' }),
      method: 'GET',
      url: `${URLADDON}/${orderId}?${queryParameters}`,

      validateStatus: (status) => {
        return status < 500;
      },

      withCredentials: true,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const getVipAddonsToBuy = (vipObject, orderIdFromAPI) => {
  // default to not return anything
  let returnVipAddons = [];
  let isReturnVip = false;
  if (!vipObject || typeof vipObject !== 'object') return returnVipAddons;

  if (vipObject) {
    vipObject.addonType = ADDON_DVP;
    vipObject.source = SECOND_CHECKOUT_SOURCE;
    vipObject.productOrderId = orderIdFromAPI;
    if (vipObject.excludedByUser === false && !vipObject.eligible === false) {
      isReturnVip = true;
    }
  }
  if (isReturnVip) returnVipAddons = [vipObject];

  return returnVipAddons;
};

export const getExtensionsToBuy = (extensions) => {
  // default to not return anything
  let returnExtensions = [];
  if (!extensions || typeof extensions !== 'object') return returnExtensions;

  returnExtensions = extensions.filter((extension) => {
    extension.addonType = ADDON_EXTENSION;
    extension.source = SECOND_CHECKOUT_SOURCE;

    return !extension.excludedByUser;
  });

  return returnExtensions;
};

export const getSelectedPMV = (allPMVData, excludedPMVOrderIds) => {
  let selectedPMVData = [];
  if (
    !allPMVData ||
    typeof allPMVData !== 'object' ||
    excludedPMVOrderIds.length === allPMVData.length
  )
    return selectedPMVData;

  selectedPMVData = allPMVData.filter((pmvData) => {
    pmvData.addonType = ADDON_PMV;
    pmvData.source = SECOND_CHECKOUT_SOURCE;

    return !excludedPMVOrderIds.includes(pmvData.orderLineId);
  });

  return selectedPMVData;
};
// eslint-disable-next-line consistent-return
export const getComplementaryDeals = async (orderId) => {
  try {
    return await axios({
      headers: httpCommonHeaders(),
      method: 'GET',
      url: `${URLCOMPLEMENTARYDEALS}/${orderId}`,
      validateStatus: (status) => {
        return status < 500;
      },
      withCredentials: true,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const getAddonsFromDealPosition = (deal, position) => {
  if (!deal || typeof position !== 'number') return [];

  const product = deal.products[Number.parseInt(position, 10)];

  if (!deal?.currency || !product?.id || !product?.price) return [];

  return [
    {
      addonType: ADDON_DVP,
      currency: deal?.currency,
      dealVoucherId: deal?.id,
      dealVoucherProductId: product.id,
      price: product.price,
      source: SECOND_CHECKOUT_SOURCE,
    },
  ];
};

export const setExcludedDropdownItem = (
  excludedIds,
  orderLineId,
  setExcludedIds,
) => {
  let updatedExcludedIds;
  if (excludedIds.includes(orderLineId)) {
    updatedExcludedIds = excludedIds.filter((id) => id !== orderLineId);
  } else {
    updatedExcludedIds = [...excludedIds, orderLineId];
  }
  setExcludedIds(updatedExcludedIds);

  return updatedExcludedIds;
};

export const uncheckAllDropdownItems = (setExcludedIds) => {
  setExcludedIds([]);
};
export const checkAllDropdownItems = (extensions, setExcludedIds) =>
  setExcludedIds(extensions?.map((extension) => extension.orderLineId));
